<template>
  <div class="form-box">
    <FormTitle :infoName="infoName" />
    <div class="form-list">
      <el-form :model="ruleForm" ref="ruleForm" label-position="top" class="demo-ruleForm" @submit.native.prevent>
        <el-form-item label="请上传论文(word格式)" class="form-item-pc-show h5-form-item">
          <div class="upload-item">
            <div style="width: 100%;" v-loading="openUploadLoading" v-if="!uploadShow"><!--!uploadShow-->
              <el-upload ref="upload" action="#"
                         class="upload-demo"
                         :limit="1"
                         drag
                         :accept="uploadFile.accept"
                         :show-file-list="false"
                         :http-request="uploadSmallFile"
                         :before-upload="beforeAvatarUpload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
              <div class="upload-format">
                <span>支持：</span>
                <img class="tip-icon" alt="word" :src="iconWord">
<!--                <img class="tip-icon" alt="pdf" :src="iconPdf">-->
                <span>文件小于15M</span>
              </div>
            </div>
            <div class="upload-box" v-if="uploadShow"><!--uploadShow-->
              <div class="upload-flex">
                <div class="left">
                  <img :src="iconWordMax" alt="word" v-if="uploadFile.type && uploadFile.type.toLowerCase() === 'docx' || uploadFile.type.toLowerCase() === 'doc'">
                  <img :src="iconPdfMax" alt="pdf" v-if="uploadFile.type && uploadFile.type.toLowerCase() === 'pdf'">
                </div>
                <div class="right">
                  <div class="title">{{uploadFile.value ? uploadFile.value.name : ''}}</div>
                  <div class="upload-state">
                    <div class="upload-icon">
                      <i class="el-icon-success" style="color: #5c9eff"></i>
                      <span>上传成功！</span>
                    </div>
                    <div class="upload-icon delete" @click="resetUpload">
                      <i class="el-icon-delete" style="color: #e31c1c"></i>
                      <span>删除</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="upload-input">
                <span class="label">请确认PPT标题：</span>
                <el-input type="text" v-model="ruleForm.title" placeholder="请输入PPT标题" />
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="h5-form-item" label="请选择页数">
          <el-radio-group v-model="ruleForm.pageNum" class="radio-pc-show">
            <el-radio-button v-for="item in pageNumList" :key="'page_num_' + item" :label="item">{{item + '页'}}</el-radio-button>
          </el-radio-group>
          <el-radio-group v-model="ruleForm.pageNum" class="radio-h5-show h5-el-radio">
            <el-radio v-for="item in pageNumList" :label="item">{{item + '页'}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="h5-form-item" label="请选择模版">
          <div class="template-box template-pc-show">
            <div class="template-item" :class="{'active-item':activeId === item.id}" v-for="item in showPptTemplate">
              <div class="template-btn">
                <div class="e-btn" @click.prevent="openPreview(item)">预览</div>
                <div class="e-btn" @click="selectPreview(item)">选中</div>
              </div>
              <div class="form-check" v-if="activeId === item.id"><i class="el-icon-check"></i></div>
              <img :src="item.image" alt="image">
            </div>
            <div class="template-text">
              <span @click="seeMore" v-if="!more">查看更多>></span>
              <span @click="closeSeeMore" v-else>收起>></span>
            </div>
          </div>

          <div class="template-box template-h5-show">
            <div class="template-item" v-if="!templateValue" @click="openSelectPic">
              <div style="height: 70px;line-height: 70px;text-align: center;background-color: #ffffff;">
                <i class="el-icon-picture" style="color: #d4d4d4; font-size: 20px;"></i>
              </div>
            </div>
            <div class="template-item active-item" v-else @click="openSelectPic">
              <div class="form-check"><i class="el-icon-check"></i></div>
              <img :src="templateValue.image" alt="image">
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn">
      <el-checkbox class="form-check" v-model="btnInfo.checked">{{btnInfo.title}}</el-checkbox>
      <el-button style="width: 180px" type="primary" :disabled="!btnInfo.checked" @click="submitForm">立即创作</el-button>
    </div>

    <NoticeWrapper />

    <el-dialog :title="'《'+dialog.title+'》'"
               :visible.sync="pptDialogVisible"
               :modal-append-to-body="false"
               class="dialog-box"
               @close="closePreview"
               :destroy-on-close="true"
               center>
      <div class="dialog-img">
        <img v-if="dialog.url" :src="dialog.url" class="avatar" alt="preview">
      </div>
    </el-dialog>

    <el-drawer title="选择模版"
               direction="btt"
               custom-class="drawer-h5-demo"
               :visible.sync="showSelectPic"
               :before-close="closeSelectPic">
      <div class="drawer-h5-box">
        <div class="template-item" :class="{'active-item':activeId === item.id}" v-for="item in pptTemplateList" @click="selectH5Pic(item)">
          <div class="form-check" v-if="activeId === item.id"><i class="el-icon-check"></i></div>
          <img :src="item.image" alt="image">
        </div>
      </div>
      <div class="demo-footer">
        <el-button @click="openPreview(selectPicItem)">预览</el-button>
        <el-button type="primary" @click="selected">确定</el-button>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import PptAIApi from "@/api/pptAi"
import { orderMixin } from '@/utils/orderMixin'
import DrawerH5 from '@/components/drawerH5/drawerH5.vue'
import FormTitle from "@/components/FormTitle/index.vue"
import NoticeWrapper from "@/components/NoticeWrapper/index.vue"
import TitleInfoBox from "@/components/titleInfoBox/index.vue"
import { PAPER_CONFIRM_TIP } from '@/assets/constant.json'
export default {
  components: {TitleInfoBox, NoticeWrapper, FormTitle, DrawerH5 },
  mixins: [orderMixin],
  props: ['infoName'],
  data() {
    return {
      ruleForm: {
        creationDocId: '',
        fileKey: '',
        pageNum: 0,
        shareCode: '',
        templateIds: [],
        title: ''
      },
      btnInfo: {
        title: PAPER_CONFIRM_TIP,
        checked: true
      },
      iconTxt: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAG5JREFUOE9j3Hfs/H8GMgAjSKOjpQFJWvcfv8BAPY2Xb95n+Pj5G4oLxIQFGNQUpeFiWG08cuYqw9v3nxhu3HsMVqihJMsgKyXKYKStgl8jTHbj7uNgpr+rJYb/8fpxVCM1EwAxaQ8eHcQoRlcDAL9Xc4srMAYvAAAAAElFTkSuQmCC',
      iconWord: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAASZJREFUOE9jPHPvw38GMgAjSKOxIj9JWs/e/8gwwBobt39gsFRgZ3DT5GSYceQzw5uv/xhq3PkZjt//ybD5yjeGNl9BsJcwnLrq/FeG99/+MaRb8zLkrn7H8PXXP4Z50SIMIPFvv/4zJJjzYNd49vEvhiWnvzK0+wowZK16y8DGwsjQ5CXAMOvYFwZbZXYGexUO7Bo/fv/HkLT0LUO5Kx/DwTs/GbjZGBlURFgYlp39ytDlL8ggxsuMXSNINGL+awZHNQ4GOUEWBg4WRobrL38zHLn7g2FRrAgDCzMjbo1Vm98z3Hz1h2FCkCADFxsjQ8bKdwwyAiwM/UGQgMEaOCDBFWe/Mqy9+I1heTzEhuiFbxjsVdgZ0qx58WskJglRnnKIsQVdDQCEraptTema1QAAAABJRU5ErkJggg==',
      iconPdf: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAARFJREFUOE+d0ruKwlAQgOE/l12za2XnDSSFdlYivoMPYJdGSOVD2FjYiG9gY6VWtuIb2GinjYiNYCWCZr2cZEkWFoKJZneaU5zzzZkZRjoPBg7/CMmFH7Xan6g1HBII74sF19GImGmi5HIPSUPhbTJBrNeopRJquRwdiuWSS6/Hu2GgFovRIUJwbjbRGg3kVCo6tHc7vrpd5HwerV4HRfHh0B6v4zFSIoGYz5HTaaRMBk4nL5E7rEDoHI9Y7TZv1Sr2dotzOGBvNkjZLM5+z2er9Qjvsxm36RRZ11ErFRRd90p0Sxerlfe7Uij44aXf/8mcTKKZ5tOF8JVqdTpI8Tgxw/DOZxE6nFf79wtfPQy6/wZzWJ3xMmOuUQAAAABJRU5ErkJggg==',
      iconWordMax: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABsCAYAAADufnWPAAAJA0lEQVR4Xu2dfZCNVRzHv2d3LbYlIbKSlyxZXBWlvGzLSl6iTXmJCMMgjUaTYWKYDI2ZGlMGu03Ga0JCkSYiGyKNSYSitheKXihSXmr3/ppjXe69zznPPc9zn/Ms3XP/MuOc7+93Ps/3npffcy4MYZ+s2ReapiSljAVYRzDUZkBq+N//H/5MwPnsG2lalzrB3Q+2LrdB95hYKEAgn6Yw0CQAKbqDlrV+/XQqHt6QiimJ8nRDvgg4kE9jGOiVsh64X/HrpxOGZxJAOK8bMmtSQJmpRPvxP5wOZA/sMmDeQDNkFsinuQw0yi/3XA1xIgBrhswC+cEiBjS4GgbuVw4WwBohc8DnGFDBr8FdDXGEgDVBZi3yg3Q1DNrPHKSANUA2gEVP1sOFzwCWfXU8gmwA281NHkA2gGNN/nFCNoBjAY5z4TOAVQDHAdkAVgXsErIB7ASwC8gGsFPADiEbwG4AO4BsALsFrAg5IQHXvY4wopFHJZgY++SEBFy1POHZLI8AX3JyUlJyXtfWzPKOLyEB89cYE5oRKpeLZ36I6itxcoICBnJqEjpneOhiyZycsIBTGDCiURC10zx0sQBywgLmLNJTgP71g6iX7j3k0Jyc0IA5Vn5vocUNhJbVCLUqAmle3Qq5NCcnPGCPvXtZjt8gKgHLM4B1ES7VLTSADWC9BDSrGwcbwJoJaJY3DjaANRPQLG8cbABrJqBZ3jjYANZMQLO8cbABrJmAZnnjYANYMwHN8sbBBrBmAprljYOvGcAFDwL33Hz5p88ReXdbSjh2xt1QCgcDVSpYdWdsJyznv0918XmxM3B/A3GuecsJ359yISru4p2De2cBE7PFSU/bSnjroPOkm9cAlvQSa358hDD6PeeayQzYNpQhTXDp5OhpQo9lzjVtengHuMZ1wMaBYhhbviOMdfEPB4xsBYxsJda8UAy0X0D4p8QZkFYZwLyeYs3FewkzdzrTi9HaO8A80BuPMGTdaA159l+g/XxCicOLNDK9UIQn1xN2HHUGZPRdwPCWYsCD3yZ8/rMzPV8BD78TGH23OPlhawm7j6knXy0N2DxIrBVSWXmQMH2ruqadCU6dJ+QugmMT+Aq4cTVgRW8xlPl7CLN2qcPo2RiY2sEe8LEzhG5L1TXtHtr6w4SJH6prKbb0dorgQd8bAGRUsoI5+BvQf5X6HGG30ocPzsmq3y0TeCFX/NCe3UjY9K0iNvVm3gMe1wYYEBAPIncx4eTZ2NnZrfTRvWfuJCzeG1uTt5jeEejeyJobXzBzFhHO/aum46CV94Bb1wZe7SEGPHkLYe2h2OnZrfTRvT/5kTDy3diavIVsT+12y6cQ1XvA3H2FgxkqlbeGV53nxrQGht5hP/+G1FXdx3c3fFci+jxfSFjzlQIu5028B2z3VeQrdc7C2Fmu6QvUv8EKY89x4I5a1v4q8+ewO4GnJDuczksIv/4dOy8XLfQA7p4JTJcsJgNXE774VZ5qRiW+UFrhfvcHYd5nYt3VXxKmfmQ//AUP8Ydj1d33C2HQGhfo1LroAVyxHLB9CENykjWL2Z+WgpJ9Hs0CJgmO3Hybt2BP6fQTrfvLX4QHXpdr8ny2DWFIEeQz51PCazb5qHGUttIDmIeTFX/2HCcMeUee9pxuQNtbrE4LHVRkTnzkTULR72LdTg2AlzqL51+7fnHCvbiuaru+2q8ZMKGddVDFQaDDQsKZf6zppyaXOq181C3z8KO27LRo982YfB/Qq4k1Fw3FnehB6QNsV/yRLUpt6gBzu1tBvP8NYcKm0txvrQqs6iNaAOXfDNnhZ+k+wos7PPCpXEIfYB5zxaMMjatbo8sWpQntgH7NrPCi988bHgdqpke2k30z6lUB3u7nTX3ExaPQC1hWbpQtSjKn5SwknDp/ZXiyr/z4DwgbiiIxDGoBPHOvFfCZCwDXdVrhcwhZL2C74k90DUHmNNE2KrsuMKurFdraQ4TJWyIRyBZN1UOPQ6D+zcGhSKKvM/+76BqCzGkFuwkFuyPz5tuuwiesi+GJs4ROi6+0lS2avIXI7XHCFHXX62AeUTavRtcQ5vUEWmVYXckrcLwSF/2RbQPDDzKyRVP1eO0BcP2AZcWf8EHKDgInzxJywxwZPuABzYFxba0PJNzxssqekwJRnJD1A7YrPYZe+cgOAnZH4DqVgXX97Y++sprG9K2ElS5ewrqArR8wT2pGJ6BLQyuM5fsJM7YDsl1BrCLOuseAOtdbdfnugL81FtU0eD4aizv+L3I8oqz4c+Q0oecyYNMgoHpaJKiSINBugX0RXDYFPLe5FLCopuH0zYoL14Z38cfBlVLFRRqeCXepqE6gMk/K5ne+BUtNEV8u0VzcKRsH86iyVZ/XA0Rfc5VXQXwbxqtr0ZdI+CGCV9xEl0v6riQcOhmnL9W7++Ngno9s1Zfl2uMNwtE/Y49kVlcgu67a2w+nb6FjR4/Zwj/AskK6KEUnVa6HbwOm5KgB9qG4U3ZTBI8sK/5EZ+UEhF3VLlp3xDrCrp9ius7LBv45mGdtd20pfFROQbzVB2hY1d7Fbq9vxUnbX8B2b3ZDA+Eg+D7WyaU+lQfnU3GnbKcIHl1W/All5uYm5u03AQvz7B08cTNh/ddx+tF5d38dzPObmA30zpLDcHNHwe4uBo+pcmhxzk6ph/+AZRWuULpuj7Gy4zjXVTm0KOFy3sh/wLLDAc89nmOs3V2MeH5u4JxpRA//AfPw/Goq3xdHfw78Bmz7wd2QqlTg7/PEfVceAE6ec6cbZ6+yARxn0tdSdwNY89MygA1gzQQ0yxsHG8CaCWiWNw42gDUT0CxvHGwAayagWd442ADWTECzvHGwAayZgGZ542ADWDMBzfLGwQawZgKa5Y2DtQMO5AcvMCBVc6DElCdsZIH8YBEDGiQmAb2jDoLms0A+zWWgUXpDJaZ6CVhf1qSAMssR7TfThMcmIHZ4bzJKfxgcmENPsyR62eMQCSvH/6uz4pLinINPpe66fEms+Vwan8RoGgCv/su6xARMOFVMrNeB0ezij3ojbuE1LaCsZMJYEOWCobaZNtQ8QsBfDCgCsXXnkvHK4RHsRKjnf7PmuN3HUSlOAAAAAElFTkSuQmCC',
      iconPdfMax: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABsCAYAAADufnWPAAAFfklEQVR4Xu3dQWgUZxQH8P+b2VS0sUQvtiCYjTSEFkkT25K2x3pt2ksPQdIku+lBPKRWhCBeBKEHaYuH3FK0jSDorbk00II9pBjbQKsegggFG/FUEZca2Xw7X/lCdt3dmcnO7MzbjTNvT0l2933zfvP2fTPfTBJC1UPn8weUo78E0WEAAwB2VT+flK+t7gMnrGx2hUZHf+LOicoDqIn8mIaeAdHL3IO2Oz51dRXtt/oBoo+5kTeAi7ncFwT6tt2Jt2p86uqCPTgAOE6RG5n0xMSgAt0Ekd2qBNs9TgXYbAgzMhUn8peIMNbupFs5fg0wM7IBvkeEg61MsN1juYAZkWk9l38GYEe7k27l+J7ATMgGWLcyue0wli8wA7IAe+3xGCc+Afb7SMWELMBb9awYkAW40aQQEVmAGwFHnPgEOAhwBGQBDgrcJLIAhwFuAlmAwwKHRBbgZoBDIAtws8ABkQU4CnAA5FQCY+dOZN4bikr7/P1bnIykExhA5oP3gR0xrtL6IKcW2Mp2w8pm46tin3aRWmDYFjKDg8Du3fEj2/YwHT26YAKnF9hk39EBu78f9AoD8uYtAekGNsiWBeu1V0F79oA6O4FdMd1r4zjrIBoW4HgbxPNoWj8D9CcCzAVs4mpcF2AB5hRgji0VLMDMAszhpYIFmFmAObxUsAAzCzCHlwoWYGYB5vBSwQLMLMAcXipYgJkFmMNLBQswswBzeKlgAWYWYA4vFSzAzALM4aWCBZhZgDm8VPA2BrY+GoZ15MNgW1goAE+fQv+zCuf3m9ArK57vCxVTKeDJE+jHj6EfPoS+dcs3bv1gmQsXgm133avU1FS490Wp4FAY1ZulFPSff6E094NrY5uOaSKZuPfvw1lYaAidbOBNVv3Hsgs5EnB5dykF5/qvcOZ/9K22VACb7J2ff6mBiAV4k9VZXIRz9aon8gsNXN2nqK8P1jvvgt58A+a2fddjdRXq/PnKj/2A63sfDQ3Ber0X1JMF9u71rlSlULp2DfrGDdfzXsD1Oztcs/V5NUcP9poIDLQ9Pu5GVgrq5MnQwNXp2JOToEOHvDOs24HlFyUO2CTmB1G6cqVSZUEruF5zq9ZSHT/RwH4I1R/NZoE3duDx46DeXlcl69u3UZqdrfl5IiuYG3ijDR075m4Vjx5BnT2bfGC/FlHds6NUsBHMnD4N7NtXi7y2BjU9nWxg30muUIA6cybSJFcz4fm0ifqJNzEtotFhWv3JRtQK9uvDQYAbHZY1dRjHcZjWaEMrz3v0RgGu0ot01lUooHT5smvNQIBjANZ376I0M+NZ6JGBp6ZAPT21setOZjYmwyZW07ZviygvKz54AOfOHc9T17JIVODMuXPuX41Ny2FakN4cBdisT9gjI+k90eAGzpw6Bezf7xomNafKnMD26Gegt83f9a97pGmxhwvYdzUtTcuVQXDNa4L24CDrwV5XTBK9mhYEOdKxddUAW+H6HaY1dRjWKCmOM7nQV15jOLauhDDX45aWfC8VSQWHuRXAY0Irzc83vKIsFRzzvRZen+IXYjWtUfuR5+UPcvDXQJRJjn/rEjCCADPvRAEWYGYB5vBSwQLMLMAcXipYgJkFmMNLBQswswBzeKlgAWYWYA4vFSzAzALM4aWCBZhZgDm8VLAAMwswh5cKFmBmAebwUsECzCzAHF4qWICZBZjDmwouTuTvEeEg81CpDK+hvzPAl4gwlkoB5qSJMELFscnDZDlLILKZx0tb+NXMerGPTNbrudw0QF+lTYAtX63XAH2k4+LF3zaAzUPlcp9r0DcAOtkGTkFgDfyNEn360vezyybdCrD5Ro+PdyuyToDI/MrOAICY/j1gwmW1/heEZWhazKji1zQ391854/8BDUdXXF/ztCUAAAAASUVORK5CYII=',
      openUploadLoading: false,
      uploadFile: {
        value: null,
        // source: null,
        accept: '.docx',
        type: '',
        state: 0    // 0默认，1成功，2失败
      },
      uploadShow: false,
      pptTemplateList: [],
      showPptTemplate: [],
      pageNumList: [],
      dialog: {
        title: '',
        url: ''
      },
      pptDialogVisible: false,
      more: false,
      activeId: '',
      templateValue: null,
      selectPicItem: null,
      showSelectPic: false
    }
  },
  created() {
    this.getAIpptpPageNum()
    this.getAIpptTemplateList()
  },
  methods: {
    // 上传组件钩子
    beforeAvatarUpload(file){
      // console.log('file=',file)
      this.uploadFile.value = file
      this.uploadFile.type = file.name.substring(file.name.lastIndexOf('.')+1)
      this.ruleForm.title = file.name.slice(0, file.name.lastIndexOf('.'))
    },
    // 上传附件
    uploadSmallFile(){
      // this.closePaper()
      this.openUploadShow()
      const formData = new FormData()
      formData.append('file', this.uploadFile.value)
      // formData.append('source', this.uploadFile.source)
      const headers = {'Content-Type': 'multipart/form-data'}
      let time = new Date().getTime()
      let key = localStorage.getItem('key')
      let ticket = localStorage.getItem('ticket')
      let setOf = ticket + time + ticket + ticket + time + ticket
      let infoMd5 = this.$md5(setOf)
      PptAIApi.postAIpptUpload(headers,formData,key,time,infoMd5).then(res => {
        // console.log(res.data)
        this.ruleForm.fileKey = res.data
      }).catch(()=>{
        this.resetUpload()
      })
    },
    // 获取支持的AIPPT支持的页数
    getAIpptpPageNum(){
      PptAIApi.getAIpptpPageNum().then(res => {
        this.pageNumList = res.data
        // 初始化默认第一个
        this.ruleForm.pageNum = res.data[0]
      }).catch(() => {
      })
    },
    // 获取支持的AIPPT模板
    getAIpptTemplateList(){
      PptAIApi.getAIpptTemplateList().then(res => {
        this.pptTemplateList = res.data
        // 初始化给4个
        let list = JSON.parse(JSON.stringify(this.pptTemplateList))
        this.showPptTemplate = list.splice(0,4)
        this.activeId = this.showPptTemplate[0].id
        this.templateValue = this.showPptTemplate[0]
      }).catch(() => {
      })
    },
    // 获取预览
    openPreview(item){
      this.dialog.title = item ? item.title : this.templateValue.title
      this.dialog.url = item ? item.preview : this.templateValue.preview
      this.pptDialogVisible = true
    },
    // 关闭预览
    closePreview(){
      this.pptDialogVisible = false
      setTimeout(()=>{
        this.dialog.title = ''
        this.dialog.url = ''
      },200)
    },
    // 选择模板 PC
    selectPreview(item){
      // console.log(item)
      this.activeId = item.id
    },
    // 选择模板 H5
    selectH5Pic(item){
      // console.log(item)
      this.activeId = item.id
      this.selectPicItem = item
    },
    selected(){
      this.templateValue = this.selectPicItem
      this.closeSelectPic()
    },
    // 更多
    seeMore(){
      this.more = true
      this.showPptTemplate = JSON.parse(JSON.stringify(this.pptTemplateList))
    },
    closeSeeMore(){
      this.more = false
      let list = JSON.parse(JSON.stringify(this.pptTemplateList))
      this.showPptTemplate = list.splice(0,4)
    },
    openUploadShow(){
      this.uploadShow = true
    },
    openSelectPic(){
      this.showSelectPic = true
    },
    closeSelectPic(){
      this.showSelectPic = false
      this.selectPicItem = null
    },
    resetUpload(){
      this.uploadShow = false
      this.$refs.upload.clearFiles()
      this.uploadFile = {
        value: null,
        // source: null,
        accept: '.docx',
        type: '',
        state: 0
      }
      this.ruleForm.fileKey = ''
      this.ruleForm.title = ''
    },
    submitForm() {
      let _this = this
      if(!_this.ruleForm.fileKey) return _this.$message.error('请上传论文!')
      if(!_this.ruleForm.title) return _this.$message.error('PPT标题不能为空!')
      _this.ruleForm.templateIds[0] = _this.activeId
      _this.ruleForm.creationDocId = 18
      if(localStorage.getItem('shareCode')){
        _this.ruleForm.shareCode = localStorage.getItem('shareCode')
      }
      _this.createOrder(_this.ruleForm)
    },
    createOrder(data){
      let _this = this
      let dataParams = {
        creationDocId: 18,
        creationDocCode: 'AIPPT',
        info: null
      }
      let time = new Date().getTime()
      let key = localStorage.getItem('key')
      let ticket = localStorage.getItem('ticket')
      let setOf = ticket + time + ticket + ticket + time + ticket
      let infoMd5 = _this.$md5(setOf)
      PptAIApi.postAIpptCreateOrder(data,key,time,infoMd5).then(res => {
        dataParams.info = res.data.id
        _this.$router.push({name: 'IntelligentPay', params: dataParams})
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/assets/css/pageContent";
/deep/ .upload-demo{
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
  .el-upload{
    display: block;
    .el-upload-dragger{
      width: auto;
      height: 150px !important;
      .el-icon-upload{
        margin: 20px 0 16px !important;
      }
    }
  }
  .el-upload__tip{
    margin: 0;
    height: 24px;
    line-height: 24px;
  }
  .el-upload-list{
    overflow: auto;
    max-height: 160px;
  }
}
.upload-item{
  position: relative;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 10px 0;
  border: 1px dashed #d4d4d4;
  border-radius: 10px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .upload-format{
    margin-top: 6px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .tip-icon{
      margin-right: 8px;
      width: 14px;
      height: 14px;
    }
    > span{
      line-height: 20px;
      color: #999999;
    }
  }
  .upload-box{
    .upload-flex{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      .left{
        margin-right: 20px;
        img{
          width: 40px;
          height: auto;
        }
      }
      .right{
        .title{
          max-width: 300px;
          line-height: 20px;
        }
        .upload-state{
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          .upload-icon{
            display: flex;
            flex-direction: row;
            align-items: center;
            i{
              margin-right: 6px;
              font-size: 14px;
            }
            span{
              font-size: 12px;
            }
          }
          .delete{
            cursor: pointer;
            span{
              color: #e31c1c;
            }
          }
        }
      }
    }
    .upload-input{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .label{
        width: 150px;
        font-size: 12px;
      }
    }
    .upload-delete{
      margin-left: 10px;
      color: #e31c1c;
      cursor: pointer;
      i{
        font-size: 18px;
      }
      span{
        margin-left: 6px;
        color: #e31c1c;
      }
    }
    .upload-tip-span{
      margin-top: 10px;
      line-height: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      i{
        margin-right: 6px;
        font-size: 16px;
      }
      span{
        font-size: 12px;
        color: #3c3c3c;
      }
    }
  }
}
.template-box{
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  .template-item{
    position: relative;
    width: 20%;
    margin: 0 0 20px 3%;
    border: 1px solid #d4d4d4;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
    img{
      display: block;
      width: 100%;
      height: auto;
    }
    .template-btn{
      position: absolute;
      z-index: 9;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.5);
      transition: opacity 0.5s ease-out;
      opacity: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      .e-btn{
        width: 54px;
        min-width: 54px;
        height: 28px;
        line-height: 28px;
        border-radius: 5px;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        border: 1px solid #ffffff;
      }
      .e-btn:hover{
        border-color: #5c9eff;
        background-color: #5c9eff;
      }
    }
    .form-check {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      text-align: right;
      /deep/ .el-icon-check {
        position: absolute;
        z-index: 8;
        bottom: 3px;
        right: 4px;
        font-size: 16px;
        color: #ffffff;
      }
    }
    .form-check::after {
      position: absolute;
      display: block;
      content: '';
      right: -40px;
      bottom: -60px;
      width: 0;
      height: 0;
      border-top: 40px solid transparent;
      border-right: 40px solid transparent;
      border-bottom: 40px solid transparent;
      border-left: 40px solid #3575fd;
      transform: rotate(50deg);
    }
  }
  .template-item:hover{
    .template-btn{
      //display: flex;
      opacity: 1;
    }
  }
  .active-item{
    border: 1px solid #5c9eff;
  }
  .template-text{
    width: 100%;
    text-align: right;
    span{
      cursor: pointer;
      color: #5c9eff;
    }
  }
}
.template-pc-show{display: flex}
.template-h5-show{display: none}
.dialog-box {
  /deep/ .el-dialog {
    width: 720px;
    min-width: 720px !important;
    height: 90vh;
    margin-top: 5vh !important;
    border-radius: 15px;
    display: flex;
    flex-direction: column;

    .el-dialog__close {
      font-size: 24px;
    }

    .el-dialog__body {
      height: calc(100% - 54px);
      padding: 0;
    }
  }

  .dialog-img {
    width: 100%;
    height: calc(100% - 20px);
    text-align: center;
    overflow: auto;

    img {
      width: 90%;
      max-width: 768px;
    }
  }
}
@media screen and (max-width: 900px) {
  /deep/ .upload-demo{
    width: 85%;
    .el-upload{
      width: 100% !important;
      .el-upload-dragger{
        width: 100% !important;
        height: auto !important;
      }
    }
    .el-upload__tip{
      height: auto !important;
      line-height: 20px;
    }
  }
  .template-box {
    .template-item {
      width: 45%;
      margin: 0 0 15px 5%;
    }
    .template-text{
      text-align: center;
    }
  }
  .template-pc-show{display: none}
  .template-h5-show{display: block}
  /deep/ .drawer-h5-demo{
    height: 75vh !important;
    .el-drawer__header{
      margin-bottom: 10px;
      .el-icon-close{
        font-size: 20px !important;
      }
    }
    .drawer-h5-box{
      width: 90%;
      height: calc(100% - 60px);
      padding: 10px 0;
      margin: 0 auto;
      overflow: auto;
      display: flex;
      flex-direction: row;
      align-content: flex-start;
      justify-content: space-between;
      flex-wrap: wrap;
      .template-item {
        position: relative;
        width: 45%;
        margin: 0 0 20px 3%;
        border: 2px solid #e9e9e9;
        border-radius: 10px;
        overflow: hidden;
        cursor: pointer;
        img {
          display: block;
          width: 100%;
          height: auto;
        }
        .form-check {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          text-align: right;
          .el-icon-check {
            position: absolute;
            z-index: 8;
            bottom: 3px;
            right: 4px;
            font-size: 16px;
            color: #ffffff;
          }
        }
        .form-check::after {
          position: absolute;
          display: block;
          content: '';
          right: -40px;
          bottom: -60px;
          width: 0;
          height: 0;
          border-top: 40px solid transparent;
          border-right: 40px solid transparent;
          border-bottom: 40px solid transparent;
          border-left: 40px solid #3575fd;
          transform: rotate(50deg);
        }
      }
      .active-item{
        border: 2px solid #5c9eff;
      }
    }
    .demo-footer{
      width: 90%;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .el-button{
        width: 47.5%;
      }
    }
  }
  .upload-item{
    .upload-box{
      .upload-flex{
        padding: 0 15px;
      }
      .upload-input{
        margin: 10px;
        padding: 10px;
        border-radius: 10px;
        background-color: #f4f4f4;
        flex-direction: column;
        align-items: flex-start;
        .label{
          width: 100%;
          text-align: center;
        }
      }
    }
  }
  .dialog-box{
    /deep/ .el-dialog{
      width: 90%;
      min-width: 300px !important;
      height: 88vh;
      .el-dialog__header{
        padding: 20px 30px 10px;
        .el-dialog__title{
          font-size: 14px;
        }
        .el-dialog__headerbtn{
          top: 10px;
          right: 10px;
        }
      }
      .el-dialog__body{
        width: 100%;
        height: calc(100% - 54px);
        padding: 0;
        .dialog-img{
          width: 100%;
        }
      }
    }
  }
}
</style>
